import { PropsWithChildren } from "react";
import ClientAdSettings from "@components/Advertisement/components/ClientAdSettings/ClientAdSettings";
import { GTMProvider } from "@elgorditosalsero/react-gtm-hook";
import MyBTFollowedKeywords from "@features/mybt/components/MyBTFollowedKeywords";
import { AuthDetails } from "@features/mySph/AuthDetails";
import RefreshAuthWithRedirect from "@features/mySph/RefreshAuthWithRedirect";
import { PostHogProvider } from "@features/posthog/hooks/usePosthogProvider";
import useIsAppWebView from "@hooks/useIsAppWebView";
import { LightboxProvider } from "@sphtech/idpf-lightbox-react";
import { NeuronProvider } from "@sphtech/neuron";
import {
  gtmId,
  IS_PLAYWRIGHT,
  ROUTES_TO_EXCLUDE_COMMON_FOOTER,
} from "@util/constant";
import { neuronConfig } from "@util/neuron/constants";
import NeuronImplementation from "@util/neuron/NeuronImplementation";

import Footer from "./components/Footer/Footer";
import IdleTimer from "./components/IdleTimer/IdleTimer";

type ProvidersRootProps = {
  pathname: string;
  isWithAuth: boolean;
} & PropsWithChildren;

const ProvidersRoot = ({
  pathname,
  isWithAuth,
  children,
}: ProvidersRootProps): React.ReactElement => {
  const isAppWebView = useIsAppWebView();

  if (IS_PLAYWRIGHT) {
    return (
      <LightboxProvider>
        <GTMProvider state={{ id: gtmId }}>
          <IdleTimer />

          {children}
        </GTMProvider>

        {!ROUTES_TO_EXCLUDE_COMMON_FOOTER.includes(pathname) &&
        !pathname.startsWith("/pulse") &&
        !isAppWebView ? (
          <Footer />
        ) : null}
      </LightboxProvider>
    );
  }

  if (!isWithAuth) {
    return (
      <GTMProvider state={{ id: gtmId }}>
        <IdleTimer />

        {children}
      </GTMProvider>
    );
  }

  return (
    <LightboxProvider>
      <NeuronProvider config={neuronConfig}>
        <NeuronImplementation />

        <PostHogProvider>
          <GTMProvider state={{ id: gtmId }}>
            <IdleTimer />

            <MyBTFollowedKeywords />
            <ClientAdSettings />
            <RefreshAuthWithRedirect />
            <AuthDetails />

            {children}
          </GTMProvider>

          {!ROUTES_TO_EXCLUDE_COMMON_FOOTER.includes(pathname) &&
          !pathname.startsWith("/pulse") &&
          !isAppWebView ? (
            <Footer />
          ) : null}
        </PostHogProvider>
      </NeuronProvider>
    </LightboxProvider>
  );
};

export default ProvidersRoot;
